"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.common = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _lodash = _interopRequireDefault(require("lodash"));
var common = exports.common = {
  data: function data() {
    return {
      lookupList: {}
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['functions'])),
  created: function created() {},
  methods: {
    hasPermission: function hasPermission(module, functionId) {
      if (this.functions) {
        var moduleData = this.functions[module];
        if (moduleData) {
          return _lodash.default.includes(moduleData, functionId);
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getLookupTypeCode: function getLookupTypeCode(configItemCodeList) {
      var _this = this;
      var param = {
        configItemCodeList: configItemCodeList
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this.lookupList) {
          _this.generateMapping(key, _this.lookupList[key] || []);
        }
        _this.searchData();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this2 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this2.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    }
  }
};